import {
	buildEscapioMinPriceState,
	NO_PRICES_STATE,
} from "../api/prices-state";
import * as Board from "../components/board";
import { travelData } from "./travelData";

/**
 * @returns true, if there is an active escapio rate (can be unavailable) for this hotel, false otherwise
 *
 * @TODO pass supported currency/-ies from backend
 */
export function hasEscapioRate(hotel) {
	return Boolean(
		travelData.currency == "EUR" &&
			hotel.active_rates &&
			Object.keys(hotel.active_rates).length > 0,
	);
}

export function getEscapioDiscount(hotel, offer) {
	return hasEscapioRate(hotel) && offer?.rate?.id
		? hotel.active_rates[offer?.rate.id]?.discount || null
		: null;
}

/**
 * Gets rate with minimal price matching optional filter if possible
 *
 * @param {object} hotel
 * @param {string} board
 * @param {bool} hasFreeCancelation
 * @returns {object} min-price or no-prices state
 */
export function tryEscapioMinRateState(
	hotel,
	board = null,
	hasFreeCancelation = false,
) {
	if (!hasEscapioRate(hotel)) {
		return NO_PRICES_STATE;
	}

	const rate = Object.values(hotel.active_rates)
		.filter(
			rate =>
				(!board || Board.isAtLeast(board, rate.board)) && !hasFreeCancelation,
		)
		.reduce(
			(minRate, rate) =>
				!minRate || rate.min_price < minRate.min_price ? rate : minRate,
			null,
		);
	return rate ? buildEscapioMinPriceState(rate, travelData) : NO_PRICES_STATE;
}

export function selectBestRate(rates) {
	return rates.reduce(
		(chosen, other) =>
			!chosen
				? other
				: chosen.bestPrice &&
					  other.bestPrice &&
					  other.bestPrice <= chosen.bestPrice
					? other
					: chosen.bestPrice &&
						  other.bestPrice &&
						  other.bestPrice > chosen.bestPrice
						? chosen
						: chosen.bestPrice && !other.bestPrice
							? chosen
							: !chosen.bestPrice && other.bestPrice
								? other
								: // Use min price as fallback.
									other.rate.min_price < chosen.rate.min_price
									? other
									: chosen,
		null,
	);
}
